import { VintageItemPayload } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  CustomTitle,
  VintagePriceColumn,
  VintageStockColumn,
  VintageListActionsColumn,
  VintageColumnMovile
} from 'src/components'

const vintageItemListColumns: ColumnsType<VintageItemPayload> = [
  {
    title: () => <CustomHeaderText text='Projects.Year' />,
    responsive: ['sm'],
    render: (_, vintage) => <CustomTitle label={`${vintage.year}`} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Projects.Price' />,
    responsive: ['sm'],
    render: (_, vintage) => <VintagePriceColumn vintage={vintage} />
  },
  {
    title: () => <CustomHeaderText text='Projects.Stock' />,
    responsive: ['sm'],
    render: (_, vintage) => <VintageStockColumn vintage={vintage} />
  },
  {
    title: () => <CustomHeaderText text='Projects.Vintage' />,
    responsive: ['xs'],
    render: (_, vintage) => <VintageColumnMovile vintage={vintage}  />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered/>,
    responsive: ['sm', 'xs'],
    render: (_, vintage) => <VintageListActionsColumn vintage={vintage} />
  },
]

export default vintageItemListColumns
